import { ReactComponent as CaretRight } from 'assets/icons/Caret Right.svg'
export const CaretIcon = ({ className = '', ...props }: { className: string }) => {
  return <CaretRight className={className} {...props} />
}
